import { render, staticRenderFns } from "./Coexistence.vue?vue&type=template&id=20744886&"
import script from "./Coexistence.vue?vue&type=script&lang=js&"
export * from "./Coexistence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20744886')) {
      api.createRecord('20744886', component.options)
    } else {
      api.reload('20744886', component.options)
    }
    module.hot.accept("./Coexistence.vue?vue&type=template&id=20744886&", function () {
      api.rerender('20744886', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/channels/Coexistence.vue"
export default component.exports